import _ from 'lodash';
import moment from 'moment';

// Keep in sync with `packages/payments/pay_later_utils.js`
export const BNPL_MIN_DEFERRAL_DAYS = 7;
export const BNPL_CHARGE_BUFFER_DAYS_DEFAULT = 6;

export function isDealAboveBnplMinimum(deal, settings) {
    const min_price = _.get(settings, 'bnpl_minimum_booking_amount', 0);
    if (!min_price || min_price <= 0) {
        return true;
    }
    return deal.totalPrice >= min_price;
}

export function getBnplChargeBufferDays(settings) {
    return _.get(settings, 'bnpl_charge_buffer_days', BNPL_CHARGE_BUFFER_DAYS_DEFAULT);
}

export function getBnplChargeDateFromCancellation(cancellationDate, settings) {
    return moment(cancellationDate).subtract(getBnplChargeBufferDays(settings), 'days');
}

export function isBnplChargeDateEligible(cancellationDate, settings) {
    return (
        getBnplChargeDateFromCancellation(cancellationDate, settings).diff(moment(), 'days') >= BNPL_MIN_DEFERRAL_DAYS
    );
}
